<template>
  <el-card class="box-card bg">
    <div class="clearfix" slot="header">Στατιστικά Αξιολογητών
      <el-button style="float: right; padding: 3px 0;" type="text" @click="toggleConsultantsList">
        Κλείσιμο
      </el-button>
    </div>
    <div class="filters">
      <el-date-picker
        v-model="dateFrom"
        type="date"
        placeholder="Από"
        format="dd-MM-yyyy"
        value-format="dd-MM-yyyy"
        :picker-options="{ disabledDate: (time) => disabledFromDates(time, dateTo) }"
      />
      <el-date-picker
        v-model="dateTo"
        type="date"
        placeholder="Εώς"
        format="dd-MM-yyyy"
        value-format="dd-MM-yyyy"
        :picker-options="{ disabledDate: (time) => disabledToDates(time, dateFrom) }"
      />
      <el-button type="primary" @click="showConsultantsList" :disabled="!activeSearchButton" :loading="waitingResponse">
        Αναζήτηση...
      </el-button>
    </div>
    <div>
      <el-table
        :data="consultantsList" style="width: 100%"
        :default-sort="tableSort"
        show-summary
        :header-cell-style="{ 'padding': '12px 0' }"
        :cell-style="{ 'padding': '12px 0' }"
      >
        <el-table-column prop="fullName" label="Ονοματεπώνυμο" width="400" sortable/>
        <el-table-column prop="total" label="Αιτήσεις" width="120" align="center" sortable/>
        <el-table-column prop="yearlyTotal" label="Σύνολο έτους" width="150" align="center" sortable/>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import axios from 'axios'
import config from '../../config.js'

export default {
  data () {
    return {
      dateFrom: '',
      dateTo: '',
      returnedList: [],
      tableSort: {
        prop: 'fullName',
        order: 'ascending'
      },
      waitingResponse: false
    }
  },
  methods: {
    disabledToDates (date, dateFrom) {
      return dateFrom && date < new Date(dateFrom.split('-').reverse().join('/'))
    },
    disabledFromDates (date, dateTo) {
      return dateTo && date > new Date(dateTo.split('-').reverse().join('/'))
    },
    toggleConsultantsList () {
      this.$store.dispatch('SHOW_HIDE_CONSULTANTS_LIST')
    },
    showConsultantsList () {
      this.waitingResponse = true
      const url = `${config.BASE_URL}/presidents/consultants_stats?date-from=${this.dateFrom}&date-to=${this.dateTo}`
      axios.get(url)
        .then(response => {
          if (response.data.success) {
            this.returnedList = response.data.data
          } else {
            console.log('Failure', response)
          }
          this.waitingResponse = false
        })
        .catch(err => {
          console.log('Error', err)
          this.waitingResponse = false
        })
    }
  },
  computed: {
    activeSearchButton () {
      return this.dateFrom && this.dateTo
    },
    consultantsList () {
      return this.returnedList.map((consultant) => {
        return {
          fullName: consultant.surname + ' ' + consultant.firstname,
          total: consultant.total,
          yearlyTotal: consultant['yearly_total']
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filters {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.el-button {
  margin-left: 30px
}

.el-table .cell {
  line-height: 23px;
}

.el-input {
  width: 200px
}

.bg-dark {
  background: #80c1ff;
}

.bg {
  background: #cce6ff;
}

.bg-light {
  background: #e6f3ff;
}

.el-form-item__label {
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  padding-right: 20px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ConsultantsList.vue